import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#loading-state" }),
  /*#__PURE__*/_createTextVNode(" Loading state ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " When Loading ends, we always need to show the real UI with data to our end users. with the attribtue loading we can control whether showing the DOM. You can also use slot default to structure the real DOM element. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { style: {"margin-right":"16px"} }, "Switch Loading", -1)
const _hoisted_6 = { style: {"padding":"14px"} }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","justify-items":"space-between","margin-top":"16px","height":"16px"} }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: "https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png",
  class: "image"
}, null, -1)
const _hoisted_9 = { style: {"padding":"14px"} }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Delicious hamberger", -1)
const _hoisted_11 = { class: "bottom card-header" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Operation button")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_el_space = _resolveComponent("el-space")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_space, {
        direction: "vertical",
        alignment: "flex-start"
      }, {
        default: _withCtx(() => [
          _createVNode("div", null, [
            _hoisted_5,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.loading,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_skeleton, {
            style: {"width":"240px"},
            loading: _ctx.loading,
            animated: ""
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, {
                variant: "image",
                style: {"width":"240px","height":"240px"}
              }),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_el_skeleton_item, {
                  variant: "h3",
                  style: {"width":"50%"}
                }),
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"margin-right":"16px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"30%"}
                  })
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_card, { "body-style": { padding: '0px', marginBottom: '1px' } }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode("div", _hoisted_11, [
                      _createVNode("span", _hoisted_12, _toDisplayString(_ctx.currentDate), 1),
                      _createVNode(_component_el_button, {
                        type: "text",
                        class: "button"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}